import { useEffect as e } from "react";
//#region src/lib/useThemeColorMeta.ts
var t = "meta[name=\"theme-color\"]";
function n() {
	let e = getComputedStyle(document.body).backgroundColor;
	if (!e) return;
	let n = document.head.querySelectorAll(t);
	n.forEach((e, t) => {
		t > 0 && e.remove();
	});
	let r = n[0];
	r || (r = document.createElement("meta"), r.name = "theme-color", document.head.appendChild(r)), r.removeAttribute("media"), r.content = e;
}
function r() {
	e(() => {
		n();
		let e = new MutationObserver(n);
		return e.observe(document.documentElement, {
			attributes: !0,
			attributeFilter: ["class", "data-theme"]
		}), () => e.disconnect();
	}, []);
}
//#endregion
export { n as syncThemeColorMeta, r as useThemeColorMeta };

//# sourceMappingURL=useThemeColorMeta.js.map